import { Outlet, useLocation } from 'react-router-dom';
import { TaskTimerProvider } from '@/features/projects/lib/work-item-timer';
import { Sidebar } from '@/shared/components/Sidebar';

/** Shell autenticado: sidebar + conteudo da rota. */
export function AppLayout() {
  const { pathname } = useLocation();
  const isProjectDetail = /^\/projetos\/[^/]+/.test(pathname);
  return (
    <TaskTimerProvider>
      <div className="flex h-screen overflow-hidden">
        <Sidebar />
        <main
          className={
            isProjectDetail
              ? 'flex min-h-0 flex-1 overflow-hidden py-4 pr-4'
              : 'flex-1 overflow-y-auto p-4'
          }
        >
          <Outlet />
        </main>
      </div>
    </TaskTimerProvider>
  );
}
